import { render, staticRenderFns } from "./CreateSegment.vue?vue&type=template&id=77ac22ae"
import script from "./CreateSegment.vue?vue&type=script&lang=js"
export * from "./CreateSegment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\_ASNET\\01_projects\\05_chatannie\\01_git\\chatbot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77ac22ae')) {
      api.createRecord('77ac22ae', component.options)
    } else {
      api.reload('77ac22ae', component.options)
    }
    module.hot.accept("./CreateSegment.vue?vue&type=template&id=77ac22ae", function () {
      api.rerender('77ac22ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Segment/Modals/CreateSegment.vue"
export default component.exports